import { MutableRefObject } from "react";
import Lottie from "react-lottie";
import { InView } from "react-intersection-observer";
import { useState } from "react";

import styles from "./lottieFilePlayer.module.scss";

type Props = {
  lottieFile: {
    name: string;
    style: string;
  };
  className: string;
  imageRef?: MutableRefObject<any>;
};

export default function LottieFilePlayer({
  lottieFile,
  className,
  imageRef,
}: Props) {
  let defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [isStopped, setIsStopped] = useState(true);

  function handleLottiePlayerOptions() {
    let Options;
    switch (lottieFile.name) {
      case "conception-web":
        if (lottieFile.style === "hero") {
          const CWanim = require("public/images/lottiefiles/cw-hero.json");
          Options = {
            ...defaultOptions,
            animationData: CWanim,
          };
          return Options;
        }

        if (lottieFile.style === "block") {
          const CWanim = require("public/images/lottiefiles/cw-block.json");
          Options = {
            ...defaultOptions,
            animationData: CWanim,
          };
          return Options;
        }

        if (lottieFile.style === "anchor") {
          const CWanim = require("public/images/lottiefiles/cw-anchor.json");
          Options = {
            ...defaultOptions,
            animationData: CWanim,
          };
          return Options;
        }

      case "marketing-web":
        if (lottieFile.style === "hero") {
          const MWanim = require("public/images/lottiefiles/cmw-hero.json");
          Options = {
            ...defaultOptions,
            animationData: MWanim,
          };
          return Options;
        }
        if (lottieFile.style === "block") {
          const MWanim = require("public/images/lottiefiles/cmw-block.json");
          Options = {
            ...defaultOptions,
            animationData: MWanim,
          };
          return Options;
        }
        if (lottieFile.style === "anchor") {
          const MWanim = require("public/images/lottiefiles/cmw-anchor.json");
          Options = {
            ...defaultOptions,
            animationData: MWanim,
          };
          return Options;
        }
      case "social-media":
        if (lottieFile.style === "hero") {
          const SManim = require("public/images/lottiefiles/rs-hero.json");
          Options = {
            ...defaultOptions,
            animationData: SManim,
          };
          return Options;
        }
        if (lottieFile.style === "block") {
          const SManim = require("public/images/lottiefiles/rs-block.json");
          Options = {
            ...defaultOptions,
            animationData: SManim,
          };
          return Options;
        }
        if (lottieFile.style === "anchor") {
          const SManim = require("public/images/lottiefiles/rs-anchor.json");
          Options = {
            ...defaultOptions,
            animationData: SManim,
          };
          return Options;
        }
    }
  }

  return (
    <InView
      ref={imageRef}
      as="div"
      className={`${className} ${styles["lottie-file"]}`}
      threshold={0.9}
      onChange={(inView, entry) => {
        if (inView && entry.isIntersecting && isStopped) {
          setIsStopped(false);
        } else if (!inView && !isStopped) {
          setIsStopped(true);
        }
      }}
    >
      <Lottie
        options={handleLottiePlayerOptions()}
        height={"100%"}
        width={"100%"}
        isStopped={isStopped}
      />
    </InView>
  );
}
